export default {
  text_1_1: '백업은 그 어느 때보다 간단하고 안전합니다.',
  text_1_2: '개인정보 요구를 충족하는 강화 옵션.',
  text_2_1: '내구성이 높고 휴대가 간편하며 굽힘에 강함.',
  text_2_2: 'CC EAL6+ 보안 인증',
  text_2_3: '칩—어디서나 휴대하세요.',
  text_2_4: '굴곡에 강하고, 자석 및 정전기 차단.',
  text_2_5: '최대 500,000회 카드 스와이프 지원.',
  text_3_1:
    'TokenPocket 기반으로 KeyPal Card 사용 시 완벽한 사용자 경험을 제공합니다.',
  text_4_1: 'PIN 코드 지원으로 보안 강화',
  text_4_2:
    'PIN을 연속 10회 잘못 입력하면 카드가 자동으로 삭제됩니다.',
  text_4_3: '백업뿐 아니라 서명에도 사용',
  text_4_4:
    '카드는 백업 용도를 넘어, 트랜잭션 서명의 핵심 구성 요소로도 작동합니다.',
  text_4_5: 'NFC 원터치 백업—간단하고 안전.',
  text_4_6: '전자기장을 통한 빠른 양방향 암호화를 활성화하여 신속하고 간편한 백업을 구현.',
  text_5_1: '지금 시작하세요 — 당신의',
  text_6_1: '지갑',
  text_6_2:
    '모든 KeyPal Card가 연결되는 뛰어난 지갑 경험을 위해 매끄럽게 통합됩니다!',
  text_6_3: '백업',
  text_6_4:
    '지갑 백업을 쉽고 안전하게 수행하여, 잘못된 백업으로 인한 자산 손실 위험을 제거합니다.',
  text_6_5: '서명',
  text_6_6:
    'KeyPal Card로 다양한 지갑 활용을 열어, 모든 서명을 손쉽게 수행하세요.',
};
